import { setActivityCardData, setDailyCallActivityData } from '@cp/src/reducers/leaderboardSlice';
import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { Dispatch } from '@reduxjs/toolkit';

export const fetchActivityCardData =
  (setIsLoading: (isLoading: boolean) => void, agentReferenceId: string) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.AGENT_ACTIVITY_TRACKER, { agentReferenceId });
    return axiosInstance
      .get(url, {
        headers: { donotHandleError: true, includeInUptimeMetrics: true },
        params: { agentReferenceId }
      })
      .then(response => {
        dispatch(setActivityCardData(response?.data));
      })
      .catch(error => {
        toast.error(error?.message || 'Error fetching activity card data');
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

export const fetchCallData =
  (setIsLoading: (isLoading: boolean) => void, agentReferenceId: string) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.AGENT_CALL_ACTIVITY_DATA, { agentReferenceId });
    return axiosInstance
      .get(url, {
        headers: { donotHandleError: true, includeInUptimeMetrics: true },
        params: { agentReferenceId }
      })
      .then(response => {
        dispatch(setDailyCallActivityData(response?.data));
      })
      .catch(error => {
        toast.error(error?.message || 'Error fetching call data');
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
